import { useI18nContext } from "@hopper-b2b/i18n";
import ShieldIcon from "./shield.svg?react";
import UpDownIcon from "./upDown.svg?react";
import "./styles.scss";

export interface IDescriptionBlock {
  capAmount: string;
}

export const DescriptionBlock = ({ capAmount }: IDescriptionBlock) => {
  const { t } = useI18nContext();

  return (
    <div className="checkout-price-freeze-tos">
      <div className="tos-info icon-card-container">
        <div className="icon-card-icon">
          <UpDownIcon className="tos-icon img-icon" alt="" />
        </div>
        <div className="icon-card-details">
          <span className="tos-bold">
            {`${t("priceFreezePurchase.termsOfService.saveText1", {
              capAmount,
            })}`}
          </span>{" "}
          <span className="tos-light">
            {t("priceFreezePurchase.termsOfService.saveText2")}
          </span>
        </div>
      </div>
      <div className="tos-info icon-card-container">
        <div className="icon-card-icon">
          <ShieldIcon className="tos-icon img-icon" alt="" />
        </div>
        <div className="icon-card-details">
          <span className="tos-bold">
            {t("priceFreezePurchase.termsOfService.protectText1")}
          </span>{" "}
          <span className="tos-light">
            {t("priceFreezePurchase.termsOfService.protectText2")}
          </span>
        </div>
      </div>
    </div>
  );
};
